import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import mixpanel from "mixpanel-browser";
import TagManager from "@sooro-io/react-gtm-module";
import * as Sentry from "@sentry/react";

const devMode = import.meta.env.VITE_IS_DEBUG;
if (devMode !== "true") {
  Sentry.init({
    dsn: "https://61a12ff88bd0faf5f4b8c5d628e8a592@o4508133136662528.ingest.us.sentry.io/4508963629498368",
    // v11 collects user info, cookies, and bodies unless this is set. The v10
    // default (sendDefaultPii unset) did not.
    dataCollection: {
      userInfo: false,
      cookies: false,
      httpHeaders: {
        request: { deny: ["forwarded", "-ip", "remote-", "via", "-user"] },
        response: { deny: ["forwarded", "-ip", "remote-", "via", "-user"] },
      },
      httpBodies: [],
      urlQueryParams: { deny: ["forwarded", "-ip", "remote-", "via", "-user"] },
      genAI: { inputs: false, outputs: false },
      databaseQueryData: false,
      graphQL: { document: false, variables: false },
    },
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      "localhost",
      /^https:\/\/app\.promptshuttle\.com\/api/,
    ],
    // Session Replay
    replaysSessionSampleRate: 0.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
} else {
  console.debug("Dev mode, no Sentry init...");
}

const gtmId = import.meta.env.VITE_GOOGLE_TAG_MANAGER_ID;
TagManager.initialize({ gtmId });

const trackingKey = import.meta.env.VITE_MIXPANEL_TRACKING_KEY;
const enableDebug = !!(import.meta.env.VITE_IS_DEBUG === "true");
if (enableDebug) {
  mixpanel.init(trackingKey, {
    debug: true,
    track_pageview: false,
    ignore_dnt: false,
    persistence: "localStorage",
  });
  console.warn("TRACKING IN DEV MODE!");
} else {
  mixpanel.init(trackingKey, {
    debug: false,
    track_pageview: true,
    ignore_dnt: true,
    persistence: "localStorage",
  });
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
